import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import classnames from 'classnames';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import { useTranslation } from 'react-i18next';
import { FormControlLabel } from '@mui/material';
import ToggleButton from '@mui/material/ToggleButton';
import makeStyles from '@mui/styles/makeStyles';
import withStyles from '@mui/styles/withStyles';
import { palette } from '../design-system/colors';
import { QuestionHeading } from './question-heading';
import { TextTiny } from '../design-system/texts';

// customizing styling of ToggleButton
const YesNoButton = withStyles(() => ({
    root: {
        fontSize: 12,
        padding: '0.5em 1em',
        textTransform: 'none',
    },
}))(ToggleButton);

const useStyles = makeStyles(() => ({
    incorrect: {
        border: '2px solid ' + palette.lightroom.redLight,
        backgroundColor: palette.lightroom.redLightHigh,

        '& .MuiTypography-root': {
            color: palette.vibrant.red,
            fontWeight: 700,
        },
    },
    userCorrect: {
        border: '2px solid ' + palette.lightroom.aspargusLight,
        backgroundColor: palette.lightroom.aspargusLightHigh,

        '& .MuiTypography-root': {
            color: palette.evergreen.aspargus,
            fontWeight: 700,
        },
    },
}));

export const YesNoList = observer(({ ui, handleChange, value, answer }) => {
    const { t } = useTranslation('assessment');
    const classes = useStyles();
    const [choices, setChoices] = useState(value);

    const handleToggle = (optionValue, yesNoString) => {
        setChoices((choices) => ({
            ...choices,
            [optionValue]: yesNoString,
        }));
    };

    useEffect(() => {
        if (choices) {
            //If the user has answered all we fire transition to next block
            if (
                Object.keys(choices).length ===
                (Array.isArray(ui.questions) ? ui.questions.length : 0)
            ) {
                handleChange(choices, ui.actionId, null, true);
            } else {
                //handleChange(choices, null, null, true);
            }
        }
    }, [choices]);

    useEffect(() => {
        setChoices(value);
    }, [ui]);

    const resolveValue = (questionId) => {
        if (!choices || !choices[questionId]) return null;
        return `${questionId}-${choices[questionId]}`;
    };

    const isSelected = (questionId, yesNoString) => {
        if (!choices || !choices[questionId]) return false;
        return choices[questionId] === yesNoString;
    };

    return (
        <div className="section-exam">
            <div className={classnames('assessment')}>
                <div className={'assessment-question'}>
                    <QuestionHeading ui={ui} />
                    {(Array.isArray(ui.questions) ? ui.questions : []).map(
                        (question, i) =>
                        !answer ? (
                            <div className="yes-no-question">
                                <div className={'question'}>
                                    {t(question.text)}
                                </div>
                                <ToggleButtonGroup
                                    value={resolveValue(question.actionId)}
                                    aria-label={question.value + '-group'}
                                    style={{ marginLeft: '1em' }}
                                >
                                    <YesNoButton
                                        className={'yes-no-button'}
                                        value={question.value + '-yes'}
                                        selected={isSelected(
                                            question.actionId,
                                            'yes'
                                        )}
                                        onClick={(e) =>
                                            handleToggle(
                                                question.actionId,
                                                'yes'
                                            )
                                        }
                                        aria-label={'Yes'}
                                    >
                                        {t('Yes')}
                                    </YesNoButton>
                                    <YesNoButton
                                        className={'yes-no-button'}
                                        value={question.value + '-no'}
                                        selected={isSelected(
                                            question.actionId,
                                            'no'
                                        )}
                                        onClick={(e) =>
                                            handleToggle(
                                                question.actionId,
                                                'no'
                                            )
                                        }
                                        aria-label={'No'}
                                    >
                                        {t('No')}
                                    </YesNoButton>
                                </ToggleButtonGroup>
                            </div>
                        ) : (
                            <FormControlLabel
                                className={classnames(
                                    'Mui-disabled yes-no-question answer',
                                    {
                                        [classes.userCorrect]:
                                            answer.userAnswer[
                                                question.actionId
                                            ] &&
                                            answer.correctAnswer[
                                                question.actionId
                                            ].value ===
                                                answer.userAnswer[
                                                    question.actionId
                                                ].value,
                                        [classes.incorrect]:
                                            !answer.userAnswer[
                                                question.actionId
                                            ] ||
                                            answer.correctAnswer[
                                                question.actionId
                                            ].value !==
                                                answer.userAnswer[
                                                    question.actionId
                                                ].value,
                                    }
                                )}
                                key={i}
                                control={
                                    <ToggleButtonGroup
                                        aria-label={question.value + '-group'}
                                        style={{ marginLeft: '1em' }}
                                    >
                                        <YesNoButton
                                            disabled={true}
                                            className={'yes-no-button'}
                                            selected={
                                                answer.userAnswer[
                                                    question.actionId
                                                ] &&
                                                answer.userAnswer[
                                                    question.actionId
                                                ].value === 'yes'
                                            }
                                            aria-label={t('Yes')}
                                        >
                                            {t('Yes')}
                                        </YesNoButton>
                                        <YesNoButton
                                            disabled={true}
                                            className={'yes-no-button'}
                                            selected={
                                                answer.userAnswer[
                                                    question.actionId
                                                ] &&
                                                answer.userAnswer[
                                                    question.actionId
                                                ].value === 'no'
                                            }
                                            aria-label={t('No')}
                                        >
                                            {t('No')}
                                        </YesNoButton>
                                    </ToggleButtonGroup>
                                }
                                label={t(question.text)}
                                labelPlacement="start"
                            />
                        )
                    )}
                    <TextTiny color={palette.graphite.charcoal} style={{paddingTop: '12px',paddingLeft: '8px'}}>{t('Please answer all questions')}</TextTiny>
                </div>
            </div>
        </div>
    );
});
